(function () {
  var headers = document.querySelectorAll('.oddit-header');
  if (!headers.length) return;

  function isHoverPointer(e) {
    return e.pointerType === 'mouse' || e.pointerType === 'pen';
  }

  for (var h = 0; h < headers.length; h++) {
    initHeader(headers[h]);
  }

  function initHeader(header) {
    var menuToggle = header.querySelector('.oddit-header__menu-toggle');
    var drawer = header.querySelector('.oddit-header__mobile-drawer');
    var nav = header.querySelector('.oddit-header__nav');
    var overlay = header.querySelector('[data-mega-menu-overlay]');
    var megaMenu = header.querySelector('[data-mega-menu-container]');
    var megaTriggers = header.querySelectorAll('[data-mega-menu-trigger]');
    var megaPanels = header.querySelectorAll('[data-mega-menu-label]:not([data-mega-menu-trigger])');

    var megaCloseTimer = null;
    var activeTrigger = null;

    /* ---------- Mobile drawer ---------- */
    // Anchor the drawer to the actual bottom of the header bar (which can be
    // pushed down by the announcement bar) and let it fill the rest of the viewport.
    function positionDrawer() {
      if (!drawer || !nav) return;
      var navBottom = Math.max(nav.getBoundingClientRect().bottom, 0);
      drawer.style.top = navBottom + 'px';
      drawer.style.height = (window.innerHeight - navBottom) + 'px';
    }

    function openDrawer() {
      if (!drawer) return;
      positionDrawer();
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('oddit-header-menu-open');
    }

    window.addEventListener('resize', function () {
      if (drawer && drawer.classList.contains('is-open')) positionDrawer();
    });

    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('oddit-header-menu-open');
      showPrimaryLevel();
    }

    if (menuToggle) {
      menuToggle.addEventListener('click', function () {
        if (drawer && drawer.classList.contains('is-open')) {
          closeDrawer();
        } else {
          openDrawer();
        }
      });
    }

    /* ---------- Mobile 2nd-level drill-down (RC-32) ----------
       Tapping WOMEN / MEN hides the primary level and shows a matching
       second-level view (same tile styling); the back button returns. */
    var primaryLevel = drawer
      ? drawer.querySelector('[data-mobile-level="primary"]')
      : null;
    var subLevels = drawer
      ? drawer.querySelectorAll('[data-mobile-sublevel]')
      : [];

    function showPrimaryLevel() {
      for (var i = 0; i < subLevels.length; i++) {
        subLevels[i].setAttribute('hidden', '');
      }
      if (primaryLevel) primaryLevel.removeAttribute('hidden');
      if (drawer) drawer.scrollTop = 0;
    }

    function openSubLevel(id) {
      var found = false;
      for (var i = 0; i < subLevels.length; i++) {
        if (subLevels[i].getAttribute('data-mobile-sublevel') === id) {
          subLevels[i].removeAttribute('hidden');
          found = true;
        } else {
          subLevels[i].setAttribute('hidden', '');
        }
      }
      if (found && primaryLevel) primaryLevel.setAttribute('hidden', '');
      if (drawer) drawer.scrollTop = 0;
    }

    var subOpeners = drawer
      ? drawer.querySelectorAll('[data-mobile-sublevel-open]')
      : [];
    for (var so = 0; so < subOpeners.length; so++) {
      subOpeners[so].addEventListener('click', function () {
        openSubLevel(this.getAttribute('data-mobile-sublevel-open'));
      });
    }

    var subClosers = drawer
      ? drawer.querySelectorAll('[data-mobile-sublevel-close]')
      : [];
    for (var sc = 0; sc < subClosers.length; sc++) {
      subClosers[sc].addEventListener('click', showPrimaryLevel);
    }

    /* ---------- Mega menu ---------- */
    function showPanel(label) {
      for (var p = 0; p < megaPanels.length; p++) {
        if (megaPanels[p].getAttribute('data-mega-menu-label') === label) {
          megaPanels[p].style.display = '';
        } else {
          megaPanels[p].style.display = 'none';
        }
      }
    }

    function openMegaMenu(label) {
      if (!megaMenu) return;
      showPanel(label);
      megaMenu.classList.add('is-open');
      megaMenu.setAttribute('aria-hidden', 'false');
      header.classList.add('oddit-header--mega-open');
      if (overlay) overlay.classList.add('is-visible');
    }

    function closeMegaMenu() {
      if (!megaMenu) return;
      megaMenu.classList.remove('is-open');
      megaMenu.setAttribute('aria-hidden', 'true');
      header.classList.remove('oddit-header--mega-open');
      if (overlay) overlay.classList.remove('is-visible');
      for (var t = 0; t < megaTriggers.length; t++) {
        megaTriggers[t].setAttribute('aria-expanded', 'false');
      }
      activeTrigger = null;
    }

    function openMegaMenuFor(trigger) {
      clearTimeout(megaCloseTimer);
      var label = trigger.getAttribute('data-mega-menu-label');
      for (var t = 0; t < megaTriggers.length; t++) {
        megaTriggers[t].setAttribute('aria-expanded', 'false');
      }
      trigger.setAttribute('aria-expanded', 'true');
      activeTrigger = trigger;
      openMegaMenu(label);
    }

    function scheduleCloseMegaMenu() {
      clearTimeout(megaCloseTimer);
      megaCloseTimer = setTimeout(function () {
        closeMegaMenu();
      }, 300);
    }

    for (var t = 0; t < megaTriggers.length; t++) {
      (function (trigger) {
        var wrapper = trigger.closest('.oddit-header__link-wrapper') || trigger.parentElement;

        // A mouse or pen click goes to the category page (hover has already opened
        // the panel). Touch and keyboard have no hover, so their first press opens
        // the panel and a second press on the open item follows the link.
        var lastPointerType = '';
        trigger.addEventListener('pointerdown', function (e) {
          lastPointerType = e.pointerType || '';
        });

        trigger.addEventListener('click', function (e) {
          var pointer = lastPointerType;
          lastPointerType = '';
          if (pointer === 'mouse' || pointer === 'pen') return;
          var isOpen = trigger.getAttribute('aria-expanded') === 'true';
          if (isOpen) return;
          e.preventDefault();
          openMegaMenuFor(trigger);
        });

        if (wrapper) {
          wrapper.addEventListener('pointerenter', function (e) {
            if (!isHoverPointer(e)) return;
            openMegaMenuFor(trigger);
          });
          wrapper.addEventListener('pointerleave', function (e) {
            if (!isHoverPointer(e)) return;
            scheduleCloseMegaMenu();
          });
        }
      })(megaTriggers[t]);
    }

    if (megaMenu) {
      megaMenu.addEventListener('pointerenter', function (e) {
        if (!isHoverPointer(e)) return;
        clearTimeout(megaCloseTimer);
      });
      megaMenu.addEventListener('pointerleave', function (e) {
        if (!isHoverPointer(e)) return;
        scheduleCloseMegaMenu();
      });
    }

    if (overlay) {
      overlay.addEventListener('click', closeMegaMenu);
    }

    /* ---------- Escape key closes everything ---------- */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeMegaMenu();
        closeDrawer();
      }
    });

    /* ---------- Cart drawer integration ---------- */
    var cartToggles = header.querySelectorAll('[data-cart-toggle]');
    for (var i = 0; i < cartToggles.length; i++) {
      cartToggles[i].addEventListener('click', function () {
        if (window.OdditCartDrawer) {
          window.OdditCartDrawer.open();
        }
      });
    }

    /* ---------- Search drawer integration ---------- */
    var searchToggles = header.querySelectorAll('[data-search-toggle]');
    for (var s = 0; s < searchToggles.length; s++) {
      searchToggles[s].addEventListener('click', function () {
        if (window.OdditSearchDrawer) {
          window.OdditSearchDrawer.open();
        }
      });
    }

    /* ---------- Locale dropdowns (language / country) ---------- */
    var localeDropdowns = header.querySelectorAll('[data-locale-dropdown]');
    for (var ld = 0; ld < localeDropdowns.length; ld++) {
      initLocaleDropdown(localeDropdowns[ld]);
    }
  }

  function initLocaleDropdown(root) {
    var trigger = root.querySelector('.oddit-locale__trigger');
    var menu = root.querySelector('.oddit-locale__menu');
    var nativeSelect = root.querySelector('[data-locale-native]');
    var form = root.closest('form');
    var options = menu ? menu.querySelectorAll('[role="option"]') : [];
    if (!trigger || !menu || !nativeSelect || !form || !options.length) return;

    // Progressive enhancement: reveal the custom UI, hide the native <select>.
    root.setAttribute('data-enhanced', 'true');
    trigger.hidden = false;

    var activeIndex = -1;

    function selectedIndex() {
      for (var i = 0; i < options.length; i++) {
        if (options[i].getAttribute('aria-selected') === 'true') return i;
      }
      return 0;
    }

    function setActive(index) {
      if (index < 0) index = 0;
      if (index > options.length - 1) index = options.length - 1;
      activeIndex = index;
      for (var i = 0; i < options.length; i++) {
        options[i].classList.toggle('is-active', i === index);
      }
      menu.setAttribute('aria-activedescendant', options[index].id);
      options[index].scrollIntoView({ block: 'nearest' });
    }

    function isOpen() {
      return !menu.hidden;
    }

    function openMenu() {
      menu.hidden = false;
      root.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      setActive(selectedIndex());
      menu.focus();
    }

    function closeMenu(focusTrigger) {
      menu.hidden = true;
      root.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      menu.removeAttribute('aria-activedescendant');
      if (focusTrigger) trigger.focus();
    }

    function commit(option) {
      var value = option.getAttribute('data-value');
      if (!value) return;
      nativeSelect.value = value;
      // Submitting the Shopify localization form reloads the page in the
      // chosen language / country.
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.submit();
      }
    }

    trigger.addEventListener('click', function () {
      if (isOpen()) {
        closeMenu(false);
      } else {
        openMenu();
      }
    });

    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openMenu();
      }
    });

    for (var i = 0; i < options.length; i++) {
      (function (option, index) {
        option.addEventListener('click', function () {
          commit(option);
        });
        option.addEventListener('mouseenter', function () {
          setActive(index);
        });
      })(options[i], i);
    }

    menu.addEventListener('keydown', function (e) {
      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          setActive(activeIndex + 1);
          break;
        case 'ArrowUp':
          e.preventDefault();
          setActive(activeIndex - 1);
          break;
        case 'Home':
          e.preventDefault();
          setActive(0);
          break;
        case 'End':
          e.preventDefault();
          setActive(options.length - 1);
          break;
        case 'Enter':
        case ' ':
          e.preventDefault();
          if (options[activeIndex]) commit(options[activeIndex]);
          break;
        case 'Escape':
          e.preventDefault();
          closeMenu(true);
          break;
        case 'Tab':
          closeMenu(false);
          break;
      }
    });

    document.addEventListener('click', function (e) {
      if (isOpen() && !root.contains(e.target)) {
        closeMenu(false);
      }
    });
  }

  /* ---------- Search drawer ----------
     Defines window.OdditSearchDrawer so the header search buttons (wired in
     initHeader) can open it. The form submits to the search page without JS;
     this adds predictive product suggestions and open/close behaviour. */
  (function initSearchDrawer() {
    var drawer = document.querySelector('[data-search-drawer]');
    if (!drawer) return;

    var input = drawer.querySelector('[data-search-input]');
    var results = drawer.querySelector('[data-search-results]');
    var closers = drawer.querySelectorAll('[data-search-drawer-close]');
    var debounceTimer = null;
    var controller = null;

    function open() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('oddit-search-open');
      if (input) {
        setTimeout(function () {
          input.focus();
        }, 60);
      }
    }

    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('oddit-search-open');
    }

    for (var c = 0; c < closers.length; c++) {
      closers[c].addEventListener('click', close);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        close();
      }
    });

    function escapeHtml(str) {
      return String(str).replace(/[&<>"']/g, function (ch) {
        return {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;'
        }[ch];
      });
    }

    function renderResults(products) {
      if (!results) return;
      if (!products || !products.length) {
        results.innerHTML = '';
        results.hidden = true;
        return;
      }
      var html = '<ul class="oddit-search-drawer__list">';
      for (var i = 0; i < products.length; i++) {
        var p = products[i];
        var img = (p.featured_image && p.featured_image.url) || p.image || '';
        html +=
          '<li class="oddit-search-drawer__result">' +
          '<a class="oddit-search-drawer__result-link" href="' + p.url + '">' +
          (img
            ? '<img class="oddit-search-drawer__result-img" src="' + img + '" alt="" loading="lazy" width="48" height="48">'
            : '') +
          '<span class="oddit-search-drawer__result-title">' + escapeHtml(p.title) + '</span>' +
          '</a></li>';
      }
      html += '</ul>';
      results.innerHTML = html;
      results.hidden = false;
    }

    function fetchSuggestions(q) {
      if (!q) {
        renderResults([]);
        return;
      }
      if (controller && controller.abort) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      var url =
        '/search/suggest.json?q=' +
        encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, controller ? { signal: controller.signal } : undefined)
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          var products =
            data && data.resources && data.resources.results && data.resources.results.products;
          renderResults(products || []);
        })
        .catch(function () {
          /* aborted or network error — leave existing results */
        });
    }

    if (input) {
      input.addEventListener('input', function () {
        clearTimeout(debounceTimer);
        var q = input.value.trim();
        debounceTimer = setTimeout(function () {
          fetchSuggestions(q);
        }, 250);
      });
    }

    window.OdditSearchDrawer = { open: open, close: close };
  })();

  /* ---------- Cart count badge live update ---------- */
  document.addEventListener('cart:updated', function (e) {
    if (!e || !e.detail || !e.detail.cart) return;
    var cart = e.detail.cart;
    var badges = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = cart.item_count;
      badges[i].style.display = cart.item_count > 0 ? '' : 'none';
    }
  });
})();